import React from 'react';

import './ProfileDetailsCard.css';

function ProfileDetailsCard({
  icon,
  count,
  title,
}: Readonly<{
  icon: React.ReactNode;
  count: string | number;
  title: string;
}>) {
  return (
    <div className="profile-details-card flex items-center">
      <div className="profile-details-card-icon mr-[10px]">{icon}</div>
      <div>
        <p className="text-text300 m-0 p-0 text-sm font-semibold">{count}</p>
        <p className="profile-details-card-title text-text500 m-0 p-0 text-xs">
          {title}
        </p>
      </div>
    </div>
  );
}

export default ProfileDetailsCard;
